import React from 'react'
import { Link } from 'react-router-dom'
import Cotton from './../../assets/img/cotton.jpg';
import Guar from './../../assets/img/guar.jpg';
import Bajra from './../../assets/img/bajra.jpg';
import Paddy from './../../assets/img/paddy.jpg';
import Arhar from './../../assets/img/arhar.jpg';
import Til from './../../assets/img/til.jpg';
import Moth from './../../assets/img/moth.gif';
import Urad from './../../assets/img/urad.jpg';
import Maize from './../../assets/img/maize.jpg';
import Moong from './../../assets/img/moong.jpg';
const Kharif = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
        <h5>Kharif Crops</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

        <div className="row mb-1 justify-content-between">
            

            <div className="col-lg-12 mb-1">
                <h4>Cotton</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Cotton} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4">
                
                <p>HD-123, H-1117, H-1098, F-1861, H-1226</p>
                <Link to={'/products/field-crops/kharif-crops/cotton'}>View more</Link>
                </div>

            </div>
            </div>

            <div className="col-lg-12 mb-1">
                <h4>Guar</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Guar} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>HG - 365, RGC - 936, HG - 563</p>
                <Link to={'/products/field-crops/kharif-crops/guar'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Bajra</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Bajra} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>HHB - 67 (Hybrid), HHB - 94 (Hybrid), HC - 20 (Composite), HHB - 67 (Improved), HHB - 197</p>
                <Link to={'/products/field-crops/kharif-crops/bajra'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Paddy</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Paddy} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>CSR - 30, Pusa - 44, PR - 113, HKR - 47, PR - 111, Pusa RH - 10 (Hybrid), PR - 114, Pusa - 1121</p>
                <Link to={'/products/field-crops/kharif-crops/paddy'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Arhar</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Arhar} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Manak, Paras (H62 - 1)</p>
                <Link to={'/products/field-crops/kharif-crops/arhar'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Til</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Til} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>HT - 1</p>
                <Link to={'/products/field-crops/kharif-crops/til'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Moth</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Moth} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>RMO - 40</p>
                <Link to={'/products/field-crops/kharif-crops/moth'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Moong</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Moong} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>K - 851, Muskan, Asha, SML - 668</p>
                <Link to={'/products/field-crops/kharif-crops/moong'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Urad</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Urad} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>T - 9, PDU - 1</p>
                <Link to={'/products/field-crops/kharif-crops/urad'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Maize</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Maize} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>HHM - 4 (Hybrid), HQPM - 1</p>
                <Link to={'/products/field-crops/kharif-crops/maize'}>View more</Link>
                </div>

            </div>
            </div>

            
        </div>

        </div>
    </div>
  )
}

export default Kharif
